import type { U2000AutoCompleteSearchResult } from '../types/U2000AutoCompleteSearchResult';

/**
 * Normalise le retour de onSearch (tableau legacy ou objet avec meta).
 */
export function u2000NormalizeAutoCompleteSearchResult<T>(
  value: T[] | U2000AutoCompleteSearchResult<T>,
): U2000AutoCompleteSearchResult<T> {
  if (Array.isArray(value)) {
    return { results: value };
  }
  return {
    results: value.results ?? [],
    totalCount: value.totalCount,
    truncated: value.truncated,
  };
}
